<template>
<div class="xm-dropdown" :class="{ 'is-open': open }" v-bind="$attrs">
    <button class="xm-dropdown-btn"
        :class="{ 'is-animating': isAnimating }"
        :style="{ 
            background: color,
            '--hover-color': hoverColor,
            '--active-color': activeColor,
            borderRadius: radius
        }"
        @click="toggle"
        @mousedown="onMouseDown"
    >
        <span>
            <i v-if="icon" :class="icon" class="xm-dropdown-btn-icon"></i>
            <span class="xm-dropdown-btn-text">
                <slot></slot>
            </span>
        </span>
        <i :class="['el-icon-arrow-down', 'xm-dropdown-arrow', { 'is-open': open }]"></i>
    </button>
    
    <transition name="xm-dropdown-menu">
        <ul v-if="open" class="xm-dropdown-menu">
            <li v-for="item in items"
                :key="item.label"
                class="xm-dropdown-item"
                @click.stop="selectItem(item)"
                @mousedown.prevent
            >
                <i v-if="item.icon" :class="item.icon" class="xm-dropdown-item-icon"></i>
                <span class="xm-dropdown-item-text">{{ item.label }}</span>
            </li>
        </ul>
    </transition>
</div>
</template>

<script>
export default {
    name: 'XmDropdown',
    inheritAttrs: false,
    props: {
        icon: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: 'rgb(0, 82, 217)'
        },
        radius: {
            type: [String, Number],
            default: '4px'
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isAnimating: false,
            open: false
        }
    },
    computed: {
        hoverColor() {
            return this.$kit.adjustColor(this.color, 20);
        },
        activeColor() {
            return this.$kit.adjustColor(this.color, -10);
        }
    },
    mounted() {
        // 点击外部关闭下拉菜单
        document.addEventListener('click', this.onDocumentClick);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.onDocumentClick);
    },
    methods: {
        onMouseDown() {
            if (!this.isAnimating) {
                this.isAnimating = true;
                // 动画播放完成后重置状态
                setTimeout(() => {
                    this.isAnimating = false;
                }, 300);
            }
        },
        toggle() {
            this.open = !this.open;
        },
        onDocumentClick(event) {
            if (!this.$el.contains(event.target)) {
                this.open = false;
            }
        },
        selectItem(item) {
           this.$emit('select', item.command, item);
          this.open = false;
        }
    }
}
</script>

<style scoped>
.xm-dropdown {
    position: relative;
    display: inline-block;
}

.xm-dropdown-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 12px;
    transition: background 0.3s ease;
    position: relative;
    overflow: hidden;
    width:100%;
    justify-content: space-between;
}

.xm-dropdown-btn-icon {
    color: white;
    font-size: 14px;
}

.xm-dropdown-btn-text {
    color: white;
    font-size: 12px;
}

.xm-dropdown-arrow {
    font-size: 12px;
    color: white;
    margin-left: 4px;
    transition: transform 0.2s;
}

.xm-dropdown-arrow.is-open {
    transform: rotate(180deg);
}

.xm-dropdown-btn:hover {
    background: var(--hover-color) !important;
}

.xm-dropdown-btn:active {
    background: var(--active-color) !important;
}

.xm-dropdown-btn.is-animating::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.2);
    width: 0;
    animation: fill-left-to-right 0.3s ease forwards;
}

.xm-dropdown-menu {
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 10;
    min-width: 100%;
    background: #fff;
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    margin-top: 4px;
    box-shadow: 0 4px 16px 0 rgba(0,0,0,0.08);
    padding: 5px;
    list-style: none;
    margin: 0;
    animation: xm-dropdown-menu-fade-in 0.2s;
}

@keyframes xm-dropdown-menu-fade-in {
    from { opacity: 0; transform: translateY(-8px);}
    to { opacity: 1; transform: translateY(0);}
}

.xm-dropdown-item {
    padding: 6px 16px;
    margin: 6px 0px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 3px;
    font-size: 12px;
    color: #333;
    background: #fff;
    transition: background 0.2s, color 0.2s;
    position: relative;
    overflow: hidden;
}

.xm-dropdown-item:hover {
    background: #f3f3f3;
}

.xm-dropdown-item:active::before {
    content: '';
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background: linear-gradient(90deg, #dbe3fa 0%, #b2c5f8 100%);
    opacity: 0.5;
    border-radius: 3px;
    pointer-events: none;
    animation: xm-dropdown-item-active-fill 0.3s;
}

.xm-dropdown-item-icon {
    font-size: 14px;
    margin-right: 6px;
    color: #666;
}

.xm-dropdown-item-text {
    flex: 1;
    white-space: nowrap;
}

@keyframes xm-dropdown-item-active-fill {
    0% {
        width: 0;
        left: 0;
        right: 100%;
        opacity: 0.5;
    }
    100% {
        width: 100%;
        left: 0;
        right: 0;
        opacity: 0.5;
    }
}

@keyframes fill-left-to-right {
    0% {
        width: 0;
    }
    100% {
        width: 100%;
    }
}
</style>
